<template>
	<div>
		<el-dialog :title="EAform.title" :visible.sync="formOpen" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :before-close="formClose">
			<div v-loading="$store.state.formload">
				<el-form :model="EAform" :rules="EArules" ref="EAform" :label-width="$store.state.width>$store.state.minwidth?'110px':''">
					<el-form-item label="管理员" prop="user">
						<el-select v-model="EAform.user" filterable placeholder="请选择" style="width: 100%;">
							<el-option
							  v-for="item in $store.state.production.userT.list"
							  :key="item.id"
							  :label="item.username"
							  :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<div class="rl-div">{{$store.state.width>$store.state.minwidth?'':'认领物种'}}</div>
					<el-form-item :label="$store.state.width>$store.state.minwidth?'认领物种':''" prop="species">
						<div style="width: 100%;">
							<el-transfer
							  filterable
							  filter-placeholder="输入可搜索"
							  v-model="EAform.species"
							  :data="$store.getters.claimS"
							  :titles="['可认领', '认领']"
							  :props="prop">
							</el-transfer>
						</div>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="formOpen = false">取 消</el-button>
					<el-button type="primary" @click="save()">{{EAform.Bname}}</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="编辑物种信息" :visible.sync="formOpenE" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :before-close="formClose">
			<div v-loading="$store.state.formload">
				<el-form :model="Eform" :rules="Erules" ref="Eform" :label-width="$store.state.width>$store.state.minwidth?'110px':''">
					<el-row>
						<el-col :md="12">
							<el-form-item label="名称" prop="alias">
								<el-input v-model="Eform.alias" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="种类" prop="s_species_details_id">
								<el-select v-model="Eform.s_species_details_id" placeholder="请选择" style="width: 100%;">
									<el-option v-for="item in $store.state.production.speciesP.list" :label="item.name" :value="item.id" :key="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="性别" prop="csex">
								<el-select v-model="Eform.csex" placeholder="请选择" style="width: 100%;">
									<el-option label="公" value="male"></el-option>
									<el-option label="母" value="female"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="参考价值" prop="price">
								<el-input v-model.number="Eform.price" autocomplete="off">
									 <template slot="append">元/斤</template>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="图片" prop="images">
								<el-upload
								  :action="config.apiurl+'/api/common/upload'"
								  list-type="picture-card"
								  :on-remove="uploadR"
								  :on-success="uploadS"
								  :before-upload="uploadB"
								  ref="flieload">
								  <span>(未修改)</span>
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="地址" prop="address">
								<el-cascader
								  placeholder="(未修改)"
								  :options="$store.state.address"
								  v-model="Eform.address"
								  change-on-select
								  :props="props"
								  class="kuan">
								</el-cascader>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="描述" prop="description">
								<el-input
								  type="textarea"
								  :autosize="{ minRows: 2, maxRows: 4}"
								  placeholder="请输入内容"
								  v-model="Eform.description">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="formOpenE = false">取 消</el-button>
					<el-button type="primary" @click="edit()">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item>物种信息管理</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :md="24">
				<el-button type="primary" icon="el-icon-document-add" :size="$store.state.width<$store.state.minwidth?'mini':'medium'" class="add" @click="openAdd()">认领</el-button>
				<el-button type="primary" icon="el-icon-paperclip" v-if="!($store.state.width>$store.state.minwidth)" style="float: right;" size="mini" @click="exportExcel()">导出</el-button>
				<el-date-picker class="find" v-model="quantum" type="daterange" v-if="$store.state.width>$store.state.minwidth" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				<el-input v-model="find" class="find" placeholder="请输入内容" :size="$store.state.width<$store.state.minwidth?'mini':'medium'" style="top: -1px;">
					<el-button slot="append" icon="el-icon-search" @click="Find()">搜索</el-button>
				</el-input>
				<el-button type="primary" icon="el-icon-paperclip" v-if="$store.state.width>$store.state.minwidth" style="float: right;" @click="exportExcel()">导出</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-table id="table" :data="$store.state.production.species.list" size="mini" stripe border class="table">
					<el-table-column type="expand" width="20">
						<template slot-scope="props">
							<el-form label-position="left" class="slot_form">
								<el-row>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">名称</div>
										<div class="lable_value">{{ props.row.alias }}</div>
									</el-col>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">RFID编号</div>
										<div class="lable_value">{{ props.row.soleno }}</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">性别</div>
										<div class="lable_value">{{ props.row.csexName }}</div>
									</el-col>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">价值</div>
										<div class="lable_value">{{ props.row.price }}元/斤</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :md="24" class="slot_table">
										<div class="lable_name">描述</div>
										<div class="lable_value">{{ props.row.description }}</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :md="24" class="slot_table">
										<div class="lable_name">图片</div>
										<div class="lable_value">
											<img v-for="(item,index) in props.row.images.split(',')" :src="config.apiurl+ item" alt="" :key="index" class="fm-img">
										</div>
									</el-col>
								</el-row>
							</el-form>
						</template>
					</el-table-column>
					<el-table-column type="index" width="40"></el-table-column>
					<el-table-column prop="alias" label="名称"></el-table-column>
					<el-table-column prop="soleno" label="编号"></el-table-column>
					<el-table-column prop="csexName" label="性别" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<!-- <el-table-column prop="price" label="价值" v-if="$store.state.width>$store.state.minwidth">
						<template slot-scope="scope">
							<span>{{scope.row.price}}元/斤</span>
						</template>
					</el-table-column> -->
					<el-table-column prop="suserInfo.username" label="负责人" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<el-table-column prop="description" label="描述" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<el-table-column label="操作" width="160">
						<template slot-scope="scope">
							<el-button size="mini" @click="openE(scope.row)">编辑</el-button>
							<el-button size="mini" @click="openEdit(scope.row)">结档</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="pagin">
			<el-col :span="24">
				<div>
					<el-pagination background :small="$store.state.width<$store.state.minwidth" align="center" @size-change="changeSize" @current-change="nextpage" :current-page="$store.state.production.page" :page-sizes="[20, 50, 100, 200]" :page-size="$store.state.production.pagesize" :layout="$store.state.width>$store.state.minwidth?'total, sizes, prev, pager, next, jumper':'prev, pager, next'" :total="$store.state.production.claim1.page.total"></el-pagination>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	var _this;
	import FileSaver from 'file-saver';
	import XLSX from 'xlsx';
	export default {
		data() {
			return {
				formOpen: false,
				formOpenE: false,
				EAform: {
					title: "物种认领",
					Bname: "认 领",
					user: '',
					species: []
				},
				EArules: {
					user: [
						{ required: true, message: '请选择管理员', trigger: 'blur' }
					]
				},
				Eform: {
					id: '',
					alias: '',
					s_species_details_id: '',
					images: [],
					csex: '',
					price: 0,
					description: '',
					address: ''
				},
				Erules: {
					alias: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					s_species_details_id: [
						{ required: true, message: '请选择物种', trigger: 'blur' }
					],
					csex: [
						{ required: true, message: '请选择性别', trigger: 'blur' }
					],
					description: [
						{ required: true, message: '请输入描述', trigger: 'blur' }
					],
					price: [
						{ type: 'number', message: '价值必须为数字值' }
					]
				},
				find: '',
				quantum: [],
				prop: {
					label: 's_rfid_id',
					key: 'id'
				},
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad (node, resolve) {
						let val=node.path;
						_this.loadadr(val)
						.then((adr) => {
							resolve(adr);
						});
					}
				}
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal){
					
				}
			}
		},
		mounted: function () {
			this.$store.commit('pagesize',20);
			this.$store.commit('page',1);
			this.load();
			_this=this;
		},
		methods: {
			load()
			{
				this.$store.commit('mainload',true);
				this.getspecies()
				.then(()=>{
					this.$store.commit('mainload',false);
				});
			},
			changeSize(val) {
				this.$store.commit('pagesize',val);
				this.$store.commit('page',1);
				this.load();
			},
			nextpage(val) {
				this.$store.commit('page',val);
				this.load();
			},
			openAdd()
			{
				this.formOpen=true;
				this.$nextTick(()=>{
					this.$refs['EAform'].resetFields();
					this.EAform.species=[];
					this.getclaimall();
					this.getuserTall();
				});
			},
			save()
			{
				this.$refs['EAform'].validate((valid) => {
					if (valid) {
						if(this.EAform.species.length<1)
						{
							this.$message({ showClose: true, message: "至少认领一个！", type: 'warning'});
							return;
						}
						this.$store.commit('formload',true);
						let value={
							s_user_id: this.EAform.user,
							s_species_id: this.adrtrans(this.EAform.species)
						};
						this.archiveStartC(value)
						.then((response)=>{
							if(response.data.code==1)
							{
								this.formOpen=false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			Find()
			{
				let value={
					keyword: this.find
				};
				if(this.quantum!=null&&this.quantum.length==2)
				{
					value.startTime=this.quantum[0].getTime()/1000;
					value.endTime=this.quantum[1].getTime()/1000;
				}
				this.$store.commit('page',1);
				this.getspecies(value);
			},
			openEdit(value)
			{
				this.$confirm('确定结档?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					this.archiveStartA({id: value.id});
				});
			},
			edit()
			{
				this.$refs['Eform'].validate((valid) => {
					if (valid) {
						this.$store.commit('formload',true);
						let value={
							id: this.Eform.id,
							alias: this.Eform.alias,
							avatar: this.Eform.images[0],
							images: this.adrtrans(this.Eform.images),
							s_species_details_id: this.Eform.s_species_details_id,
							csex: this.Eform.csex,
							price: this.Eform.price,
							address: this.adrtrans(this.Eform.address),
							description: this.Eform.description,
						};
						this.editspecies(value)
						.then((response)=>{
							if(response.data.code==1)
							{
								this.formOpenE=false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			openE(value)
			{
				this.formOpenE=true;
				this.$nextTick(()=>{
					this.$refs['Eform'].resetFields();
					this.Eform.id=value.id;
					this.Eform.s_species_details_id=value.s_species_details_id;
					this.Eform.alias=value.alias;
					this.Eform.images=[];
					this.Eform.csex=value.csex;
					this.Eform.price=value.price;
					this.Eform.description=value.description;
					this.$refs['flieload'].clearFiles();
					this.getspeciesPAll();
				});
			},
			exportExcel() {
				/* npm install --save xlsx file-saver 需要获取依赖 */
				var wb = XLSX.utils.table_to_book(document.querySelector('.table'))
				/* get binary string as output */
				var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
				try {
					FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
				} catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
				this.$message({message: '导出成功！',type: 'success'});
				return wbout
			},
			uploadS(res, file) {
				this.Eform.images.push(res.data.url);
			},
			uploadB(file) {
				const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 和 png 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			uploadR(file, fileList) {
				console.log(file);
				this.EAform.images.remove(file.response.data.url);
			}
		}
	}
</script>

<style scoped>
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.output{
		text-align: right;
	}
	.table{
		margin-top: 10px;
		width: 100%;
	}
	.add{
		margin-top: 1px;
	}
	.find{
		width: 300px;
		margin-left: 15px;
	}
	.pagin{
		margin-top: 10px;
	}
	.fm-img{
		width: 100px;
		height: 100px;
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}
		.slot_table{
		border: 1px solid #EBEEF5;
		border-collapse: collapse ;
	}
	.slot_table>.el-form-item {
		margin-bottom: 0px;
		color: #1991FA;
	}
	.slot_form{
		width: 70%;
		margin: 0 auto;
	}
	.lable_name{
		vertical-align: middle;
		float: left;
		font-size: 14px;
		color: #606266;
		line-height: 40px;
		padding: 0 12px 0 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 30%;
		padding-left: 0.75rem;
		/* border-right: 1px solid #EBEEF5; */
	}
	.lable_value{
		line-height: 40px;
		float: left;
		font-size: 14px;
		color: #1991FA;
		width: 70%;
		text-align: center;
	}
	.rl-div{
		margin-bottom: 15px;
	}
	.kuan {
		width: 100%;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.slot_form{
			width: 100%;
		}
		.find{
			width: 100% !important;
			margin-left: 0px;
			margin-top: 5px;
		}
	}
</style>

<style>
	.el-message-box {
		width: 350px !important;
	}
</style>